import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    fill: '#0099ff',
    width: 'auto',
    height: 60,
    backgroundColor: 'transparent',
  },
  st0: {
    fill: 'white',//'#006B72',
  },
});

export const GunvorLogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      viewBox="-5 -5 168 172"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={classes.svg}
    >
      <g>
        <g>
          <path className={classes.st0} d="M142.9,134c0-2.8-1.7-4.5-4.9-4.5h-8.1v8.9h8.1C140.6,138.4,142.9,136.8,142.9,134" />
          <path className={classes.st0} d="M155.9,39.2V0.4H0v145.8v14.9h155.9v-14.9V58.6H58.5v38.8H117v19.4H39V39.3L155.9,39.2L155.9,39.2z
			 M15.3,146.2c1.4,1.7,3.5,2.8,6.3,2.8c2.7,0,4.9-1.1,6.2-2.8c1.1-1.4,1.7-3.4,1.7-5.5h-7.8v-1.8h9.7v7.4v4.1h-1.6l-0.4-4.1
			c-1.5,3.2-4.6,4.6-7.9,4.6c-4.1,0-7.1-1.9-8.8-4.6c-1.3-2-1.9-4.6-1.9-7.2c0-6.2,3.6-11.8,10.8-11.8c4.8,0,8.7,2.6,9.5,7.5h-2.2
			c-0.3-2.6-3-5.7-7.3-5.7c-6,0-8.6,5-8.6,10C13,141.6,13.7,144.3,15.3,146.2 M127.7,127.7h10.4c3.8,0,6.9,1.8,6.9,5.9
			c0,2.9-1.5,5.2-4.4,5.8c3,0.4,3.8,2.4,4,5.1c0,0.5,0,1,0.1,1.7c0.1,1.5,0.3,3.3,1,4.1h-2.4c-0.5-0.9-0.5-2.6-0.6-3.5
			c0-0.2,0-0.4,0-0.6c-0.2-3-0.7-6.1-4.5-5.9H130v5.9v4.1h-2.2v-4.1L127.7,127.7L127.7,127.7z M112.5,127.2
			c7.2,0,10.7,5.6,10.7,11.8c0,2.6-0.6,5.2-1.9,7.2c-1.7,2.8-4.7,4.6-8.8,4.6c-4.1,0-7.1-1.9-8.8-4.6c-1.3-2-1.9-4.6-1.9-7.2
			C101.8,132.8,105.3,127.2,112.5,127.2 M82.8,127.7l6.8,18.5l0.6,1.8l0.6-1.8l6.7-18.5h2.3l-6.9,18.5l-1.5,4.1H89l-1.5-4.1
			l-6.9-18.5H82.8z M59.5,127.7h2.4l12.9,18.5l0.5,0.7v-0.7h-0.2h0.2v-18.5h2.2v18.5v4.1H75l-2.9-4.1l-10.5-15v15v4.1h-2.2v-4.1
			v-18.5H59.5z M39.5,146.2c1.1,2,3.1,2.8,5.7,2.8c2.7,0,4.7-0.8,5.8-2.8l0,0c0.6-1.1,0.9-2.6,0.9-4.5v-14h2.2v14.5
			c0,1.4-0.2,2.8-0.8,4c-1.2,2.7-3.7,4.6-8.1,4.6s-6.9-1.9-8.1-4.6c-0.5-1.2-0.8-2.6-0.8-4v-14.5h2.2v14
			C38.6,143.6,38.9,145.1,39.5,146.2"/>
          <path className={classes.st0} d="M106.2,146.2c1.4,1.7,3.5,2.8,6.3,2.8s4.9-1.1,6.3-2.8c1.6-1.9,2.3-4.6,2.3-7.2c0-5-2.6-10-8.6-10
			s-8.6,5-8.6,10C103.9,141.6,104.7,144.3,106.2,146.2"/>
        </g>
      </g>
    </svg>
  );
};
